module.exports = __webpack_public_path__ + "img/wenzi1.65f51b95.webp";